var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import en from '../../strings/lang/en';
import { DataAnalytics, DataObject } from './common';
var selectPayPageNames = {
    complete: 'complete',
    disputeError: 'dispute_error',
    limitError: 'limit_error',
    planReview: 'plan_review',
    planSelection: 'plan_selection',
    serverError: 'server_error',
    start: 'start'
};
var getBusinessErrorMessage = function (event) {
    if (event === selectPayPageNames.disputeError) {
        return en.selectPay.transactionDisputesErrorHeading;
    }
    if (event === selectPayPageNames.limitError) {
        return en.selectPay.errorPromoLimitReachedHeading;
    }
    if (event === selectPayPageNames.serverError) {
        return en.common.apiErrorMessage;
    }
    return '';
};
export var getSelectPayAnalyticsEvent = function (event) { return ({
    errorMessage: getBusinessErrorMessage(selectPayPageNames[event]),
    pageFunction: 'pti_loan',
    pageKind: 'activity',
    pageName: selectPayPageNames[event],
    pageSubFunction: 'select_pay'
}); };
export var selectPayDataTypes = {
    acceptOffer: 'accept-offer',
    back: 'back',
    changeSelection: 'change-selection',
    changeTransaction: 'change-transaction',
    close: 'close',
    continue: 'continue',
    exploreMore: 'explore-more',
    promoTermDetails: 'promo-term-details',
    seeHowItWorks: 'see-how-it-works',
    xButton: 'x-button',
    banner: 'banner'
};
var getElementDataTypeValue = function (targetNameKey) { return selectPayDataTypes[targetNameKey]; };
var getElementDataReasons = function (targetNameKey) {
    if (!targetNameKey)
        return undefined;
    if (targetNameKey === 'exploreMore') {
        return 'select-pay';
    }
    if (targetNameKey === 'banner') {
        return 'synchrony-select-pay';
    }
    var digitWithoutZeroPadding = Number(targetNameKey.replace(/^0+/, ''));
    return "".concat(digitWithoutZeroPadding, "months");
};
export var getSelectPayAnalyticsProps = function (_a) {
    var targetName = _a.targetName, targetReason = _a.targetReason;
    var reason = getElementDataReasons(targetReason);
    return __assign({ 'data-object': DataObject.button, 'data-analytics': DataAnalytics.clickTrackingEvent, 'data-type': getElementDataTypeValue(targetName) }, (reason && { 'data-reason': reason }));
};
export var getSelectPayAccordionAnalyticsProps = function (toggle) {
    return {
        seeHowItWorks: {
            'data-analytics': DataAnalytics.clickTrackingEvent,
            'data-object': toggle ? DataObject.expand : DataObject.collapse,
            'data-type': selectPayDataTypes.seeHowItWorks
        }
    };
};
//# sourceMappingURL=select-pay.js.map